<script lang="ts">
    import type { ProjectFragment, ProjectSlideFragment } from '$gen/graphql';

    export let project: ProjectFragment;

    $: slides = project?.projectSlider || [];
    // $: console.log({ project });

    /** TS-Stuff */
    type StudioSHAsset = Extract<
        ProjectSlideFragment['media'][number],
        { __typename: 'studioShAssets_Asset' }
    >;
    const isStudioSHAsset = (item): item is StudioSHAsset => {
        return (item as StudioSHAsset).__typename === 'studioShAssets_Asset';
    };
</script>

{#if project}
    <article id={project.title}>
        <!-- First Project Slide always visible -->
        {#each slides.slice(0, 1) as slide_}
            <a href={`/${project.uri}`}>
                {#each slide_.media.slice(0, 1).filter(isStudioSHAsset) as media}
                    {#if media.kind === 'json'}
                        <img
                            class="w-full"
                            src={media.embeddedAsset.image}
                            alt={media.embeddedAsset.title}
                            width={media.embeddedAsset.imageWidth}
                            height={media.embeddedAsset.imageHeight}
                        />
                    {:else if media.kind === 'image'}
                        <img src={media.url} srcset={media.srcset} alt={media.title} />
                    {/if}
                {/each}
            </a>
        {/each}
    </article>
{/if}
